<template>
  <div class="evento-wrapper" ref="wrapperRef">

    <!-- Fondo -->
    <img
      :src="require('@/assets/F1.jpg')"
      alt="Fondo"
      class="fondo-textura"
    />

    <!-- Overlay elegante -->
    <div class="overlay-fondo"></div>

    <!-- Partículas -->
    <div class="particulas"></div>

    <!-- Ramita decorativa -->
    <img
      src="@/assets/ramita.avif"
      alt="Decoración"
      class="ramita-fondo-visual"
    />

    <!-- CONTENEDOR FOTOS -->
    <div class="fotos-container">

      <!-- FOTO 1 -->
      <div ref="fotoRef1" class="foto-box reveal">
        <div class="marco-luxury">
          <img
            src="@/assets/EY7A4989 2.JPG.jpeg"
            alt="Foto"
            class="foto-romantica"
          />
        </div>
      </div>

      <!-- FOTO 2 -->
      <div ref="fotoRef2" class="foto-box reveal">
        <div class="marco-luxury">
          <img
            src="@/assets/IMG_6744.webp"
            alt="Foto"
            class="foto-romantica"
          />
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {

  name: 'FotosRomanticas',

  setup() {

    const wrapperRef = ref(null)

    const fotoRef1 = ref(null)
    const fotoRef2 = ref(null)

    let observer = null

    onMounted(() => {

      const revealElements =
        wrapperRef.value.querySelectorAll('.reveal')

      observer =
        new IntersectionObserver((entries)=>{

          entries.forEach((entry)=>{

            if(entry.isIntersecting){

              entry.target.classList.add('visible')

            }

          })

        }, {

          threshold:0.08

        })

      revealElements.forEach((el, index)=>{

        el.style.transitionDelay =
          `${index * 0.08}s`

        observer.observe(el)

      })

      /* 🔥 FOTO 1 */

      gsap.fromTo(
        fotoRef1.value,
        {
          opacity:0,
          y:45,
          scale:.92,
          rotate:-2
        },
        {
          opacity:1,
          y:0,
          scale:1,
          rotate:0,
          duration:1,
          ease:'power2.out',
          scrollTrigger:{
            trigger:fotoRef1.value,
            start:'top 90%'
          }
        }
      )

      gsap.to(
        fotoRef1.value,
        {
          y:'-=8',
          duration:2.2,
          repeat:-1,
          yoyo:true,
          ease:'sine.inOut'
        }
      )

      /* 🔥 FOTO 2 */

      gsap.fromTo(
        fotoRef2.value,
        {
          opacity:0,
          y:45,
          scale:.92,
          rotate:2
        },
        {
          opacity:1,
          y:0,
          scale:1,
          rotate:0,
          duration:1,
          delay:.08,
          ease:'power2.out',
          scrollTrigger:{
            trigger:fotoRef2.value,
            start:'top 90%'
          }
        }
      )

      gsap.to(
        fotoRef2.value,
        {
          y:'-=8',
          duration:2.4,
          repeat:-1,
          yoyo:true,
          ease:'sine.inOut'
        }
      )

      /* ✨ RAMITA */

      gsap.to('.ramita-fondo-visual', {
        rotation:2,
        duration:5,
        repeat:-1,
        yoyo:true,
        ease:'sine.inOut'
      })

    })

    return {

      wrapperRef,
      fotoRef1,
      fotoRef2

    }

  }

}
</script>

<style>

@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700&display=swap');

/* ========= CONTENEDOR ========= */

.evento-wrapper{
  position:relative;

  width:100%;

  min-height:100vh;

  padding:90px 20px;

  overflow:hidden;

  display:flex;
  justify-content:center;
  align-items:center;

  z-index:1;
}

/* ========= FONDO ========= */

.fondo-textura{
  position:absolute;
  inset:0;

  width:100%;
  height:100%;

  object-fit:cover;

  z-index:0;

  transform:scale(1.05);
}

/* ========= OVERLAY ========= */

.overlay-fondo{
  position:absolute;
  inset:0;

  background:
  linear-gradient(
    rgba(255,255,255,.50),
    rgba(255,255,255,.25)
  );

  z-index:1;
}

/* ========= PARTÍCULAS ========= */

.particulas{
  position:absolute;
  inset:0;

  background-image:
    radial-gradient(rgba(255,255,255,.55) 1px, transparent 1px);

  background-size:40px 40px;

  opacity:.18;

  animation:particulasMove 14s linear infinite;

  z-index:1;
}

@keyframes particulasMove{

  from{
    transform:translateY(0);
  }

  to{
    transform:translateY(-40px);
  }

}

/* ========= RAMITA ========= */

.ramita-fondo-visual{
  position:absolute;
  top:-120px;
  left:0;

  width:100%;

  opacity:.06;

  z-index:1;

  pointer-events:none;
}

/* ========= FOTOS ========= */

.fotos-container{
  position:relative;

  z-index:5;

  width:100%;
  max-width:430px;

  display:flex;
  flex-direction:column;
  gap:34px;
}

/* ========= FOTO ========= */

.foto-box{
  display:flex;
  justify-content:center;
}

.marco-luxury{
  width:100%;

  padding:10px;

  border-radius:34px;

  background:
  linear-gradient(
    135deg,
    rgba(255,255,255,.55),
    rgba(255,255,255,.12)
  );

  backdrop-filter:blur(8px);

  box-shadow:
  0 12px 35px rgba(0,0,0,.12),
  0 0 25px rgba(255,255,255,.18);

  overflow:hidden;
}

.foto-romantica{
  width:100%;
  max-width:100%;

  border-radius:26px;

  object-fit:cover;

  box-shadow:
  0 12px 30px rgba(0,0,0,.18);

  transition:
  transform .45s ease,
  filter .45s ease;
}

.foto-romantica:hover{
  transform:scale(1.03);
  filter:brightness(1.04);
}

/* ========= REVEAL ========= */

.reveal{

  opacity:0;

  transform:translateY(35px);

  transition:
  opacity .7s ease,
  transform .7s ease;

}

.reveal.visible{

  opacity:1;

  transform:translateY(0);

}

/* ========= RESPONSIVE ========= */

@media(max-width:768px){

  .evento-wrapper{
    padding:70px 18px;
  }

  .fotos-container{
    gap:24px;
  }

  .marco-luxury{
    padding:8px;
  }

}

</style>